var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8599 5.311C22.1652 8.05835 22.7408 11.6815 21.7025 14.8566C21.7025 14.8566 21.4459 15.5614 20.7406 15.3047C20.0394 15.0494 20.2918 14.3431 20.2918 14.3431C21.154 11.6553 20.6593 8.59724 18.7108 6.27518C15.8637 2.8821 10.9297 2.27268 7.36092 4.74937L9.73353 4.95694C10.1462 4.99304 10.4514 5.35682 10.4153 5.76946C10.3792 6.1821 10.0154 6.48734 9.6028 6.45124L5.3763 6.08147C4.96367 6.04536 4.65842 5.68159 4.69452 5.26895L5.06429 1.04246C5.1004 0.62982 5.46417 0.324577 5.87681 0.360678C6.28944 0.396779 6.59469 0.760553 6.55859 1.17319L6.34344 3.63234C10.5537 0.584283 16.4665 1.26696 19.8599 5.311Z",
    className: "Icon-fill-color",
    stroke: "transparent"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.53901 18.1667C2.08731 15.2449 1.59199 11.3326 2.91375 8.02205C2.91375 8.02205 3.16816 7.31254 3.87684 7.57048C4.58215 7.82719 4.32435 8.53547 4.32435 8.53547C3.17875 11.3587 3.59323 14.706 5.68807 17.2026C8.53512 20.5955 13.4687 21.2048 17.0375 18.7283L14.6654 18.5208C14.2527 18.4847 13.9475 18.1209 13.9836 17.7083C14.0197 17.2956 14.3835 16.9904 14.7961 17.0265L19.0226 17.3963C19.4352 17.4324 19.7405 17.7962 19.7044 18.2088L19.3346 22.4353C19.2985 22.8479 18.9347 23.1532 18.5221 23.1171C18.1094 23.081 17.8042 22.7172 17.8403 22.3046L18.0555 19.8454C13.8452 22.8935 7.93235 22.2108 4.53901 18.1667Z",
    className: "Icon-fill-color",
    stroke: "transparent"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/Refresh.58dda7712162201828afdca464fadffe.svg";
export { ForwardRef as ReactComponent };